import { useGetSubscriptionIntentQuery } from '@app/__graphql__v2/types';

export default function useGetSubscriptionIntent(id: string) {
  const { data, loading, error, refetch } = useGetSubscriptionIntentQuery({
    context: {
      clientName: 'graphql-v2',
    },
    skip: !id,
    fetchPolicy: 'network-only',
    variables: { id },
  });

  return {
    subscriptionIntent: data?.subscriptionIntent,
    isSubscriptionAnUpdate: data?.subscriptionIntent
      ? data?.subscriptionIntent?.actionType !== 'NEW'
      : false,
    loading,
    error: error?.graphQLErrors?.[0] ?? error?.networkError,
    refetch,
  };
}
